import { getWebSocketBaseUrl } from '../utils/api';

/**
 * Hook to generate WebSocket URLs for fix event connections
 *
 * @param organizationId - The ID of the organization
 * @param fixId - The ID of the fix
 * @param attempt - The fix generation attempt
 * @returns WebSocket URL for the specified fix, or null if IDs are missing
 */
const useWebSocketFixUrl = (
  organizationId: string | undefined,
  fixId: string | undefined,
  attempt: number | undefined
): string | null => {
  // Only generate URLs if we have required IDs
  if (!organizationId || !fixId || !attempt) {
    return null;
  }

  const baseUrl = getWebSocketBaseUrl();

  return `${baseUrl}/organizations/${organizationId}/fixes/${fixId}/attempts/${attempt}/event`;
};

export default useWebSocketFixUrl;
